import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Content Management Fill
 */

export default function ContentManagementFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M4.5 0C4.22386 0 4 0.223858 4 0.5V3.5H2C1.72386 3.5 1.5 3.72386 1.5 4M1.5 4.0007V12H0.5C0.223858 12 0 12.2239 0 12.5V15.5C0 15.7761 0.223858 16 0.5 16H3.5C3.77614 16 4 15.7761 4 15.5V12.5C4 12.2239 3.77614 12 3.5 12H2.5V4.5H4V7.5C4 7.77614 4.22386 8 4.5 8H7.5V12H6.5C6.22386 12 6 12.2239 6 12.5V15.5C6 15.7761 6.22386 16 6.5 16H9.5C9.77614 16 10 15.7761 10 15.5V12.5C10 12.2239 9.77614 12 9.5 12H8.5V8H11.5C11.7761 8 12 7.77614 12 7.5V4.5H13.5V12H12.5C12.2239 12 12 12.2239 12 12.5V15.5C12 15.7761 12.2239 16 12.5 16H15.5C15.7761 16 16 15.7761 16 15.5V12.5C16 12.2239 15.7761 12 15.5 12H14.5V4C14.5 3.72386 14.2761 3.5 14 3.5H12V0.5C12 0.223858 11.7761 0 11.5 0H4.5"
        fillRule="evenodd"
      />
    </Icon>
  );
}
